module.exports = __webpack_public_path__ + "img/flutter.d21f1eec.png";